import * as localizationKeys from '../../../consts/localization/localizationKeys';
import * as muleSoftResponseErrorTypes from '../../../consts/muleSoft/muleSoftResponseErrorTypes';
import {getLocalizedStrings} from '../../../services/localization/localizationService';

let deviceProductName = '';

const getFormatedText = (localizationKey) => {
    const localizedStrings = getLocalizedStrings();
    const formatedText = localizedStrings.formatString(localizedStrings[localizationKey], deviceProductName);

    return formatedText;
};

const getRegistrationManualPageContent = (productName, isRegistrationFailed) => {
    const localizedStrings = getLocalizedStrings();

    deviceProductName = productName;

    const title = isRegistrationFailed
        ? getFormatedText(localizationKeys.DEVICE_REGISTRATION_FAILED_MANUAL_ENTRY_TITLE)
        : getFormatedText(localizationKeys.DEVICE_REGISTRATION_MANUAL_TITLE);

    const description = isRegistrationFailed
        ? getFormatedText(localizationKeys.DEVICE_REGISTRATION_FAILED_MANUAL_ENTRY_DESCRIPTION)
        : getFormatedText(localizationKeys.DEVICE_REGISTRATION_MANUAL_DESCRIPTION);

    const documentTitle = getFormatedText(localizationKeys.DEVICE_REGISTRATION_TITLE);
    const imageDescription = getFormatedText(localizationKeys.DEVICE_REGISTRATION_MANUAL_BOX_IMAGE_DESCRIPTION_NAMED);
    const inputLabel = localizedStrings[localizationKeys.DEVICE_REGISTRATION_MANUAL_INPUT_LABEL];
    const placeholder = localizedStrings[localizationKeys.DEVICE_REGISTRATION_MANUAL_INPUT_PLACEHOLDER_TEXT];

    return {title, description, documentTitle, imageDescription, inputLabel, placeholder};
};

const getInputErrorText = (errorType, productName) => {
    const localizedStrings = getLocalizedStrings();

    deviceProductName = productName;

    switch (errorType) {
        case muleSoftResponseErrorTypes.WRONG_DEVICE: {
            return localizedStrings[localizationKeys.DEVICE_REGISTRATION_MANUAL_WRONG_DEVICE_ERROR_MESSAGE];
        }
        case muleSoftResponseErrorTypes.INVALID_CODENTIFYID: {
            return localizedStrings[localizationKeys.DEVICE_REGISTRATION_MANUAL_ENTRY_VALIDATION_ERROR_MESSAGE];
        }
        case muleSoftResponseErrorTypes.NOT_FOUND: {
            return getFormatedText(localizationKeys.DEVICE_REGISTRATION_MANUAL_FAILED_404_ERROR_MESSAGE);
        }
        case muleSoftResponseErrorTypes.ALREADY_OWNED: {
            return localizedStrings[localizationKeys.DEVICE_REGISTRATION_MANUAL_FAILED_409_ERROR_MESSAGE];
        }
        case muleSoftResponseErrorTypes.ERROR: {
            return getFormatedText(localizationKeys.DEVICE_REGISTRATION_FAILED_400_500_ERROR_MESSAGE);
        }
        default:
            break;
    }
};

const getButtonText = (isError) => {
    const localizedStrings = getLocalizedStrings();

    return isError
        ? localizedStrings[localizationKeys.DEVICE_REGISTRATION_MANUAL_TRY_AGAIN_BUTTON_TEXT]
        : localizedStrings[localizationKeys.DEVICE_REGISTRATION_MANUAL_NEXT_BUTTON_TEXT];
};

export {getButtonText, getInputErrorText, getRegistrationManualPageContent};
